import React, { FC } from "react";

import { StyledImage } from "./Logo.styled";

interface Logo {
  type:
    | "csob"
    | "green0meter"
    | "small"
    | "green0meter-with-csob"
    | "green0meter-with-text"
    | "green0meter-with-blue-text";
  height?: number;
  width?: number;
}

const Logo: FC<Logo> = ({ type, height, width }) => (
  <StyledImage
    alt="Logo."
    src={`/static/logo/logo-${type}.svg`}
    {...{ type, height, width }}
  />
);

export default Logo;
